var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0H25.6C26.873 0 28.0939 0.505713 28.9941 1.40589C29.8943 2.30606 30.4 3.52696 30.4 4.8V19.2C30.4 20.473 29.8943 21.6939 28.9941 22.5941C28.0939 23.4943 26.873 24 25.6 24H4.8C3.52696 24 2.30606 23.4943 1.40589 22.5941C0.505713 21.6939 0 20.473 0 19.2V4.8C0 3.52696 0.505713 2.30606 1.40589 1.40589C2.30606 0.505713 3.52696 0 4.8 0ZM4.8 1.6C4 1.6 3.296 1.872 2.752 2.352L15.2 10.4L27.648 2.352C27.104 1.872 26.4 1.6 25.6 1.6H4.8ZM15.2 12.336L1.808 3.648C1.68 4 1.6 4.4 1.6 4.8V19.2C1.6 20.0487 1.93714 20.8626 2.53726 21.4627C3.13737 22.0629 3.95131 22.4 4.8 22.4H25.6C26.4487 22.4 27.2626 22.0629 27.8627 21.4627C28.4629 20.8626 28.8 20.0487 28.8 19.2V4.8C28.8 4.4 28.72 4 28.592 3.648L15.2 12.336Z",
    fill: "#B72A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.576a4d71fc28f8b6c4e895c1e44d80b4.svg";
export { ForwardRef as ReactComponent };